import React from "react";
import EventTableRow from "./EventTableRow";

const EventTableLoading = ({ showAvatars }: { showAvatars: boolean }) => {
  return (
    <>
      <EventTableRow loading showAvatars={showAvatars} />
      <EventTableRow loading showAvatars={showAvatars} />
      <EventTableRow loading showAvatars={showAvatars} />
      <EventTableRow loading showAvatars={showAvatars} />
      <tr className="cw-sr-only">
        <td>Loading...</td>
      </tr>
    </>
  );
};

export default EventTableLoading;
